import ContactosCRUD from '../components/ContactosCRUD.jsx';
export default function Proveedores() {
  return <ContactosCRUD tipo="proveedores" />;
}
